import type { TeamMember } from "../../types";

export const jlrTeam: TeamMember[] = [
  {
    name: "Glen Balliet",
    title: "Founder & CEO",
    email: "glen@null.autos",
    previousCompanies: ["CARIAD", "Rivian", "American Express", "Nike"],
    photo: "/assets/images/team/glen.jpg",
    // bio: "Automotive software veteran with deep experience building developer platforms at scale.",
  },
];
